<template>
  <div class="p-3">
    <CampaignsTable/>
  </div>
</template>

<script>
  import CampaignsTable from "@/modules/marketing/audience/campaign/CampaignsTable";
  export default {
    name: "AudienceCampaigns",
    components: {CampaignsTable}
  }
</script>

<style scoped>

</style>
